import React from 'react';
import CommonChart from '../CommonChart';
import { getCompetitorBatchLanguage } from '@/pages/opinion/services';
import { transLanguage } from '@/pages/opinion/utils';

export default function LanguageChart({
  xAxisList,
  dau,
  commonParams,
  isNoMobile,
}: any) {
  const transformFunc = (value: string) => {
    return transLanguage(value);
  };

  return (
    <CommonChart
      xAxisList={xAxisList}
      dau={dau}
      commonParams={commonParams}
      isNoMobile={isNoMobile}
      requestFunc={getCompetitorBatchLanguage}
      selectTitle="Language"
      title="Language"
      transformFunc={transformFunc}
    ></CommonChart>
  );
}
